"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FixedTooltip_1 = require("./FixedTooltip");
exports.default = FixedTooltip_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Tooltip/FixedTooltip/index.js
// module id = 1287
// module chunks = 8